import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHex = (props) => /* @__PURE__ */ _jsxs("svg", {
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	"xmlns:cc": "http://creativecommons.org/ns#",
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	width: 512,
	height: 512,
	viewBox: "0 0 135.46666 135.46667",
	id: "svg8",
	"inkscape:version": "0.92.2 5c3e80d, 2017-08-06",
	"sodipodi:docname": "hex.svg",
	"inkscape:export-filename": "/Users/asnelgrove/192.png",
	"inkscape:export-xdpi": 36.000004,
	"inkscape:export-ydpi": 36.000004,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", {
			id: "defs2",
			children: /* @__PURE__ */ _jsx("inkscape:perspective", {
				"sodipodi:type": "inkscape:persp3d",
				"inkscape:vp_x": "0 : 148.5 : 1",
				"inkscape:vp_y": "0 : 999.99999 : 0",
				"inkscape:vp_z": "209.99999 : 148.5 : 1",
				"inkscape:persp3d-origin": "105 : 98.999999 : 1",
				id: "perspective10"
			})
		}),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "base",
			pagecolor: "#ffffff",
			bordercolor: "#666666",
			borderopacity: 1,
			"inkscape:pageopacity": 0,
			"inkscape:pageshadow": 2,
			"inkscape:zoom": 1.0824912,
			"inkscape:cx": 177.27117,
			"inkscape:cy": 236.87968,
			"inkscape:document-units": "mm",
			"inkscape:current-layer": "layer1",
			showgrid: "false",
			"inkscape:window-width": 1246,
			"inkscape:window-height": 755,
			"inkscape:window-x": 34,
			"inkscape:window-y": 1,
			"inkscape:window-maximized": 1,
			"fit-margin-top": 0,
			"fit-margin-left": 0,
			"fit-margin-right": 0,
			"fit-margin-bottom": 0,
			units: "px",
			showguides: "false"
		}),
		/* @__PURE__ */ _jsx("metadata", {
			id: "metadata5",
			children: /* @__PURE__ */ _jsx("rdf:RDF", { children: /* @__PURE__ */ _jsxs("cc:Work", {
				"rdf:about": "",
				children: [
					/* @__PURE__ */ _jsx("dc:format", { children: "image/svg+xml" }),
					/* @__PURE__ */ _jsx("dc:type", { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" }),
					/* @__PURE__ */ _jsx("dc:title", {})
				]
			}) })
		}),
		/* @__PURE__ */ _jsxs("g", {
			"inkscape:label": "Layer 1",
			"inkscape:groupmode": "layer",
			id: "layer1",
			transform: "translate(-18.447052,50.715684)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#ff00ff",
						fillOpacity: 1,
						strokeWidth: 1.01174462
					},
					id: "path40",
					"sodipodi:sides": 6,
					"sodipodi:cx": 86.180382,
					"sodipodi:cy": -13.73723,
					"sodipodi:r1": 42.699039,
					"sodipodi:r2": 36.978447,
					"sodipodi:arg1": 1.0471976,
					"sodipodi:arg2": 1.5707963,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 107.5299,23.241224 -42.69904,-2e-6 -21.349518,-36.978454 21.349522,-36.978452 42.699036,2e-6 21.34952,36.978454 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#ff9c00",
						fillOpacity: 1,
						strokeWidth: 1.54607868
					},
					id: "path27",
					"sodipodi:sides": 6,
					"sodipodi:cx": 69.298385,
					"sodipodi:cy": 49.164085,
					"sodipodi:r1": 15.344394,
					"sodipodi:r2": 13.288633,
					"sodipodi:arg1": 0,
					"sodipodi:arg2": .52359878,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "M 84.642779,49.164085 76.970582,62.45272 H 61.626189 l -7.672197,-13.288635 7.672197,-13.288634 15.344393,0 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#157fff",
						fillOpacity: 1,
						strokeWidth: .99687517
					},
					id: "path34",
					"sodipodi:sides": 6,
					"sodipodi:cx": 119.54283,
					"sodipodi:cy": 54.984924,
					"sodipodi:r1": 34.370884,
					"sodipodi:r2": 29.766062,
					"sodipodi:arg1": 0,
					"sodipodi:arg2": .52359878,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 153.91372,54.984924 -17.18545,29.766059 -34.37088,0 -17.185443,-29.766059 17.185443,-29.766058 34.37088,0 z",
					"inkscape:transform-center-x": 60168996e-13
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#8a008a",
						fillOpacity: 1,
						strokeWidth: .52376419
					},
					id: "path23",
					"sodipodi:sides": 6,
					"sodipodi:cx": 42.231728,
					"sodipodi:cy": 64.44104,
					"sodipodi:r1": 18.023312,
					"sodipodi:r2": 15.608648,
					"sodipodi:arg1": 0,
					"sodipodi:arg2": .52359878,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "M 60.255039,64.44104 51.243383,80.049686 H 33.220072 l -9.011656,-15.608646 9.011656,-15.608646 18.023311,0 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#d3ff00",
						fillOpacity: 1,
						strokeWidth: .70737928
					},
					id: "path29",
					"sodipodi:sides": 6,
					"sodipodi:cx": 40.664843,
					"sodipodi:cy": 26.945387,
					"sodipodi:r1": 22.217791,
					"sodipodi:r2": 19.241173,
					"sodipodi:arg1": 1.0471976,
					"sodipodi:arg2": 1.5707963,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 51.773739,46.186559 -22.217791,-2e-6 L 18.447054,26.945386 29.55595,7.7042153 l 22.217791,1.1e-6 11.108894,19.2411716 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#d48200",
						fillOpacity: 1,
						strokeWidth: .26772085
					},
					id: "path36",
					"sodipodi:sides": 6,
					"sodipodi:cx": 117.81393,
					"sodipodi:cy": 19.061064,
					"sodipodi:r1": 5.7738719,
					"sodipodi:r2": 5.0003185,
					"sodipodi:arg1": 0,
					"sodipodi:arg2": .52359878,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 123.5878,19.061064 -2.88694,5.00032 h -5.77387 l -2.88694,-5.00032 2.88694,-5.00032 5.77387,0 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#efffa4",
						fillOpacity: 1,
						strokeWidth: .71524674
					},
					id: "path38",
					"sodipodi:sides": 6,
					"sodipodi:cx": 86.839523,
					"sodipodi:cy": 32.85994,
					"sodipodi:r1": 8.2834406,
					"sodipodi:r2": 7.1736717,
					"sodipodi:arg1": 1.0471976,
					"sodipodi:arg2": 1.5707963,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 90.981243,40.03361 -8.28344,-1e-6 -4.14172,-7.17367 4.14172,-7.17367 8.283441,1e-6 4.14172,7.17367 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#003f8b",
						fillOpacity: 1,
						strokeWidth: .45986447
					},
					id: "path43",
					"sodipodi:sides": 6,
					"sodipodi:cx": 40.051609,
					"sodipodi:cy": -1.0071097,
					"sodipodi:r1": 8.2982922,
					"sodipodi:r2": 7.1865325,
					"sodipodi:arg1": -1.0471976,
					"sodipodi:arg2": -.52359878,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 44.200755,-8.1936417 4.149146,7.1865317 -4.149146,7.186532 -8.298292,4e-7 -4.149146,-7.1865316 4.149146,-7.1865321 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#e6ff70",
						strokeWidth: .26458332
					},
					id: "path26",
					"sodipodi:sides": 6,
					"sodipodi:cx": 136.3726,
					"sodipodi:cy": 8.4827509,
					"sodipodi:r1": 17.103016,
					"sodipodi:r2": 14.811645,
					"sodipodi:arg1": -1.0471976,
					"sodipodi:arg2": -.52359878,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 144.92411,-6.3288958 8.55151,14.8116459 -8.55151,14.8116469 -17.10301,1e-6 -8.55151,-14.8116463 8.55151,-14.8116466 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#a9cd00",
						strokeWidth: .40621266
					},
					id: "path28",
					"sodipodi:sides": 6,
					"sodipodi:cx": 69.60556,
					"sodipodi:cy": 74.561646,
					"sodipodi:r1": 12.149089,
					"sodipodi:r2": 10.521418,
					"sodipodi:arg1": 0,
					"sodipodi:arg2": .52359878,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "M 81.754649,74.561646 75.680105,85.083065 H 63.531016 l -6.074545,-10.521419 6.074545,-10.52142 12.149089,0 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 73.645597,34.523964 -5.587627,0 -2.793814,-4.839028 2.793814,-4.839027 5.587628,0 2.793813,4.839028 z",
					"inkscape:randomized": 0,
					"inkscape:rounded": 0,
					"inkscape:flatsided": "true",
					"sodipodi:arg2": 1.5707963,
					"sodipodi:arg1": 1.0471976,
					"sodipodi:r2": 4.8390274,
					"sodipodi:r1": 5.5876274,
					"sodipodi:cy": 29.684937,
					"sodipodi:cx": 70.851784,
					"sodipodi:sides": 6,
					id: "path41",
					style: {
						fill: "#abd1ff",
						fillOpacity: 1,
						strokeWidth: .48247245
					},
					"sodipodi:type": "star"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 152.8554,-19.179153 -6.24681,10.8197844 -12.49361,0 -6.24681,-10.8197844 6.24681,-10.819785 12.49361,0 z",
					"inkscape:randomized": 0,
					"inkscape:rounded": 0,
					"inkscape:flatsided": "true",
					"sodipodi:arg2": .52359878,
					"sodipodi:arg1": 0,
					"sodipodi:r2": 10.819783,
					"sodipodi:r1": 12.493611,
					"sodipodi:cy": -19.179154,
					"sodipodi:cx": 140.36179,
					"sodipodi:sides": 6,
					id: "path44",
					style: {
						fill: "#0057c0",
						fillOpacity: 1,
						strokeWidth: 1.25883794
					},
					"sodipodi:type": "star"
				}),
				/* @__PURE__ */ _jsx("path", {
					"sodipodi:type": "star",
					style: {
						fill: "#ff70ff",
						fillOpacity: 1,
						strokeWidth: .45810261
					},
					id: "path46",
					"sodipodi:sides": 6,
					"sodipodi:cx": 83.587967,
					"sodipodi:cy": 64.619392,
					"sodipodi:r1": 5.3053946,
					"sodipodi:r2": 4.5946064,
					"sodipodi:arg1": 1.0471976,
					"sodipodi:arg2": 1.5707963,
					"inkscape:flatsided": "true",
					"inkscape:rounded": 0,
					"inkscape:randomized": 0,
					d: "m 86.240664,69.213999 -5.305395,0 -2.652697,-4.594607 2.652698,-4.594606 5.305394,0 2.652698,4.594607 z"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m 38.961865,-32.98342 6.703786,11.611298 -6.703785,11.6112976 -13.407572,7e-7 -6.703786,-11.6112973 6.703785,-11.611298 z",
					"inkscape:randomized": 0,
					"inkscape:rounded": 0,
					"inkscape:flatsided": "true",
					"sodipodi:arg2": -.52359878,
					"sodipodi:arg1": -1.0471976,
					"sodipodi:r2": 11.611299,
					"sodipodi:r1": 13.407572,
					"sodipodi:cy": -21.372122,
					"sodipodi:cx": 32.25808,
					"sodipodi:sides": 6,
					id: "path48",
					style: {
						fill: "#ffc870",
						fillOpacity: 1,
						strokeWidth: .74300414
					},
					"sodipodi:type": "star"
				})
			]
		})
	]
});
export default SvgHex;
